// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"DepositButton_buttonWrapper--One","wideDepositButton":"DepositButton_wideDepositButton--_Js"};